import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import QuizPage from "./pages/QUizePage";
import HomePage from "./pages/HomePage"; // העמוד הראשי שאתה כבר בנית
import ResultPage from './pages/ResultPage'
import Header from "./conponants/header";
import Footer from "./conponants/footer";
import { Box } from "@mui/material";
import ResultsPage from "./pages/ResultsPage";


function App() {
  return (
    <Box
    sx={{
      backgroundImage: "url('/background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
    }}
  >
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/result" element={<ResultPage />} />
        <Route path="/results" element={<ResultsPage />} />

      </Routes>
      <Footer />

    </BrowserRouter>
    </Box>
  );
}

export default App;
